import { Component, Inject, Type } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface DialogContentData {
  entryComponent: Type<any>
  title: string
  message?: string
  cancleCallback?: () => void
  positiveCallback?: (data?) => void
}

@Component({
  selector: 'app-game-record-webtsn-dialog',
  templateUrl: './game-record-webtsn-dialog.component.html',
  styleUrl: './game-record-webtsn-dialog.component.css'
})

export class GameRecordWebtsnDialogComponent {
  gameRecordWebTSNForm!:FormGroup

  constructor(
    public dialogRef: MatDialogRef<GameRecordWebtsnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContentData,
    private translate: TranslateService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.gameRecordWebTSNForm = this.fb.group({
      webTSNobject:[ , Validators.required]
    })
  }

  onCancle() {
    if (this.data.cancleCallback) {
      this.data.cancleCallback()
    }
    this.dialogRef.close()
  }

  onConfirm() {
    if (this.data.positiveCallback) {
      const webTSNobject = this.gameRecordWebTSNForm.value?.webTSNobject
      this.data.positiveCallback(webTSNobject)
    }
    this.dialogRef.close()
  }

}
